import { changeSidebarVisibility } from "../slices/thunks";

export const toggleSidebarMenu = (dispatch, sidebarVisibilitytype) => {
    const windowSize = document.documentElement.clientWidth;

    dispatch(changeSidebarVisibility("show"));

    if (windowSize > 767) {
        const icon = document.querySelector(".hamburger-icon");
        if (icon) icon.classList.toggle("open");
    }

    const layout = document.documentElement.getAttribute("data-layout");

    // Horizontal layout
    if (layout === "horizontal") {
        document.body.classList.toggle("menu");
    }

    // Vertical & semibox
    if (sidebarVisibilitytype === "show" && (layout === "vertical" || layout === "semibox")) {
        if (windowSize < 1025 && windowSize > 767) {
            document.body.classList.remove("vertical-sidebar-enable");
            document.documentElement.setAttribute(
                "data-sidebar-size",
                document.documentElement.getAttribute("data-sidebar-size") === "sm" ? "" : "sm"
            );
        } else if (windowSize > 1025) {
            document.body.classList.remove("vertical-sidebar-enable");
            document.documentElement.setAttribute(
                "data-sidebar-size",
                document.documentElement.getAttribute("data-sidebar-size") === "lg" ? "sm" : "lg"
            );
        } else if (windowSize <= 767) {
            // MOBILE (Round M1): toggle the off-canvas drawer instead of only
            // opening it, so the same hamburger button also closes it.
            document.body.classList.toggle("vertical-sidebar-enable");
            document.documentElement.setAttribute("data-sidebar-size", "lg");
        }
    }

    // Two column layout
    if (layout === "twocolumn") {
        document.body.classList.toggle("twocolumn-panel");
    }
};
